import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as requests from '../api/requests';
import { addErrorNotification } from './notificationsSlice';

const initialState = {
  programs: [],
};

const getDateValue = dateStr => new Date(dateStr).valueOf();

// ---------------------- ASYNC THUNKS ----------------------

export const getPrograms = createAsyncThunk(
  'programs/getPrograms',
  async (_, thunkAPI) => {
    const res = await requests.getAllPrograms();
    const body = await res.json();

    if (!res.ok) {
      thunkAPI.dispatch(
        addErrorNotification(
          body.errmsg || 'Something Went Wrong When Fetching Programs Info!'
        )
      );
    }

    return { ok: res.ok, body };
  }
);

// ---------------------- SLICE ----------------------

export const programsSlice = createSlice({
  name: 'programs',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getPrograms.fulfilled, (state, { payload }) => {
      if (payload.ok) {
        const programs = payload.body.programs.map(program => ({
          ...program,
          programDate: new Date(program.programDate).toString(),
        }));

        state.programs = programs.sort(
          (a, b) => getDateValue(b.programDate) - getDateValue(a.programDate)
        );
      }
    });
  },
});

export default programsSlice.reducer;
